import {
  array,
  boolean,
  number,
  object,
  string,
  null as zNull,
  type infer as zInfer,
} from "zod";

export const getMintsoftIntegration = {
  name: "getMintsoftIntegration" as const,
  input: zNull(),
  output: object({
    mintsoftIntegration: object({
      clientId: number(),
      returnReasonMap: array(
        object({
          redoReason: string(),
          mintsoftReasonId: number(),
          mintsoftReasonName: string(),
        }),
      ),
      defaultReturnReasonId: number(),
      defaultReturnReasonName: string(),
    }).nullable(),
    warehouses: array(
      object({
        id: number(),
        name: string(),
        code: string().optional(),
        active: boolean().optional(),
      }),
    ),
    returnReasons: array(
      object({
        id: number(),
        name: string(),
        stockAction: string().optional(),
        active: boolean().optional(),
      }),
    ),
  }),
};

export type GetMintsoftIntegrationOutput = zInfer<
  typeof getMintsoftIntegration.output
>;
